import { RoleType } from '../../app/core/services/role.service';

export interface NavItem {
  label: string;
  icon: string;
  route: string;
  roles?: RoleType[];
  children?: NavItem[];
}

export const navigationData: NavItem[] = [
  {
    label: 'Dashboard',
    icon: 'dashboard',
    route: '/dashboard',
    roles: [RoleType.Admin],
  },
  {
    label: 'Projects',
    icon: 'folder',
    route: '/projects',
    roles: [RoleType.Admin],
  },
  {
    label: 'Clients',
    icon: 'business',
    route: '/clients',
    roles: [RoleType.Admin],
  },
  {
    label: 'Users',
    icon: 'people',
    route: '/users',
    roles: [RoleType.Admin],
  },
  {
    label: 'Invoices',
    icon: 'receipt',
    route: '/invoices',
    roles: [RoleType.Admin, RoleType.Client],
  },
  {
    label: 'Timesheets',
    icon: 'schedule',
    route: '/timesheets',
    roles: [RoleType.Employee],
  },
];
